import ConfirmPage from './UnsubscribePage';

export default ConfirmPage;
